"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollectionReader = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var __1 = require("..");
var id_1 = require("../../../id");
var form_1 = require("../../form");
var collection_data_1 = require("../collection.data");
var label_drawable_1 = require("../drawable/label.drawable");
var line_drawable_1 = require("../drawable/line.drawable");
var marker_drawable_1 = require("../drawable/marker.drawable");
var image_field_1 = require("../fields/image.field");
var number_field_1 = require("../fields/number.field");
var true_size_field_1 = require("../fields/true.size.field");
var ReadUtil = tslib_1.__importStar(require("./collection.model.util"));
var IkeModelCollectionReader = /** @class */ (function () {
    function IkeModelCollectionReader(collection, schema, loader) {
        this.json = collection;
        this.schema = schema;
        this.loader = loader;
        this.collection = new collection_data_1.CollectionModel(schema, loader);
    }
    IkeModelCollectionReader.prototype.read = function () {
        var e_1, _a;
        var collectionJson = this.json;
        if (collectionJson.data != null && collectionJson.data.data != null) {
            this.collection.state.instanceId = collectionJson.data.data['_id'];
        }
        if (this.collection.instanceId == null) {
            this.collection.state.instanceId = collectionJson.objectId;
        }
        var state = this.collection.state;
        state.id = collectionJson.objectId;
        state.uuid = collectionJson.uuid;
        state.createdAt = new Date(collectionJson.createdAt);
        state.updatedAt = new Date(collectionJson.updatedAt);
        state.collectedBy = collectionJson.collectedBy;
        state.collectedWith = collectionJson.collectedWith;
        state.assignedTo = collectionJson.assignedTo;
        state.updatedBy = collectionJson.updatedBy;
        state.revision = collectionJson.revision;
        state.jobId = collectionJson.jobuuid;
        if (collectionJson.collectedAt != null) {
            state.collectedAt = core_api_1.ParseJSON.fromDate(collectionJson.collectedAt);
        }
        this.readMeasurements();
        this.readBrightnessCorrections();
        this.readCropParameters();
        this.readImageVisibilities();
        try {
            for (var _b = tslib_1.__values(this.schema.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                this.readField(this.collection, field, collectionJson.data.data);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this.collection;
    };
    IkeModelCollectionReader.prototype.readField = function (target, schema, source) {
        var value = source[schema.id];
        // Check to make sure the value actually has something interesting in it.
        if (value == null) {
            return;
        }
        // Process sub forms
        if (form_1.FormModelFieldSubForm.isSubForm(schema)) {
            return this.loadSubForm(target, schema, value);
        }
        // Text based fields can just be set
        if (schema.type === core_api_1.IkeFieldType.TEXT) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.FILE_TOOL) {
            return this.loadFileTool(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.DATE) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.YES_NO) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.SELECT_LIST) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.NUMBER) {
            return this.loadNumber(target, schema, value);
        }
        // Load in CaptureFile information
        if (schema.type === core_api_1.IkeFieldType.TRUE_SIZE) {
            return this.loadCaptures(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.IMAGE) {
            return this.loadCaptures(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.VECTOR) {
            return this.loadVector(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.ANCHOR) {
            return this.loadAnchor(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.LOCATION) {
            return this.loadLocation(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.NESTED_LIST) {
            var nlField = target.getField(schema.id);
            nlField.Mutator.manual(value[0]);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.HEIGHT) {
            return this.loadHeight(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            return this.loadVerticalSeparation(target, schema, value);
        }
        throw new Error("Unable to find field Serializer for ".concat(schema.type));
    };
    IkeModelCollectionReader.prototype.loadSubForm = function (target, schema, source) {
        var e_2, _a, e_3, _b;
        var instances = source;
        var field = target.getField(schema.id);
        if (instances.length === 0) {
            field.Mutator.clear();
        }
        try {
            for (var instances_1 = tslib_1.__values(instances), instances_1_1 = instances_1.next(); !instances_1_1.done; instances_1_1 = instances_1.next()) {
                var data = instances_1_1.value;
                var instanceId = data._id || id_1.IkeId.generate();
                field.Mutator.create(instanceId);
                var instance = field.getInstance(instanceId);
                try {
                    for (var _c = (e_3 = void 0, tslib_1.__values(schema.fields)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var f = _d.value;
                        this.readField(instance, f, data);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (instances_1_1 && !instances_1_1.done && (_a = instances_1.return)) _a.call(instances_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    IkeModelCollectionReader.prototype.loadCaptures = function (target, schema, source) {
        var e_4, _a;
        var field = target.getField(schema.id);
        if (source.length === 0) {
            if (true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                field.Mutator.clear();
            }
            else if (image_field_1.CollectionModelFieldImage.isImageField(field)) {
                field.Mutator.clear();
            }
            return;
        }
        try {
            for (var source_1 = tslib_1.__values(source), source_1_1 = source_1.next(); !source_1_1.done; source_1_1 = source_1.next()) {
                var ts = source_1_1.value;
                if (true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                    field.Mutator.add(ts.capture.objectId);
                }
                else if (image_field_1.CollectionModelFieldImage.isImageField(field)) {
                    field.Mutator.add(ts.capture.objectId);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (source_1_1 && !source_1_1.done && (_a = source_1.return)) _a.call(source_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    IkeModelCollectionReader.prototype.loadLocation = function (target, schema, source) {
        var field = target.getField(schema.id);
        var isLocationData = function (x) { return x['provider'] == null; };
        if (isLocationData(source)) {
            // We are unsure if this is actually a GPS reading or a manual reading.
            // In theory manual readings will not have accuracy
            if (source.accuracy != null) {
                field.Mutator.gps(source, null);
                return;
            }
            field.Mutator.manual(source);
            return;
        }
        if (source.provider === 'edited') {
            field.Mutator.edited(source.value);
            return;
        }
        if (source.provider === 'gps') {
            field.Mutator.gps(source.value, source);
            return;
        }
        if (source.provider === 'manual') {
            field.Mutator.manual(source.value);
            return;
        }
        field.Mutator.capture(source.capture.objectId || source.capture.uuid);
    };
    IkeModelCollectionReader.prototype.loadNumber = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (typeof source === 'number') {
            field.Mutator.manual(source);
            return;
        }
        if (typeof source === 'string') {
            field.Mutator.manual(parseFloat(source));
            return;
        }
        if (source.provider === 'manual') {
            field.Mutator.manual(source.value);
            return;
        }
        if (source.provider === 'bearing' || source.provider === 'backbearing') {
            if (source.capture == null) {
                // Some bad data doesn't have a "capture". Revert to manual.
                field.Mutator.manual(source.value);
                return;
            }
            if (source.provider === number_field_1.CollectionModelFieldNumber.PROVIDER_BEARING) {
                field.Mutator.bearing(source.capture.objectId || source.capture.uuid);
                return;
            }
            if (source.provider === number_field_1.CollectionModelFieldNumber.PROVIDER_BACK_BEARING) {
                field.Mutator.backBearing(source.capture.objectId || source.capture.uuid);
                return;
            }
        }
        if (source.provider === 'sag') {
            var points = source.points.map(function (p) { return p.objectId || p.uuid; });
            field.Mutator.sag(source.start.objectId || source.start.uuid, source.end.objectId || source.end.uuid, points);
            return;
        }
        throw new Error("Unable to find field Serializer for ".concat(schema.type, " with provider ").concat(source['provider']));
    };
    IkeModelCollectionReader.prototype.loadVector = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (ReadUtil.isVectorPointToPointProvider(source)) {
            var cc = source.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.p2p(cc);
            return;
        }
        if (ReadUtil.isVectorCollectionProvider(source)) {
            field.Mutator.collection(source.collectionId);
            return;
        }
        if (ReadUtil.isVectorProviderManual(source)) {
            field.Mutator.manual(source.value);
            return;
        }
        return;
    };
    IkeModelCollectionReader.prototype.loadAnchor = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (ReadUtil.isAnchorLocationGPS(source)) {
            field.Mutator.gps(source.value);
            if (source.antennaHeight != null) {
                field.Mutator.setAntennaHeight(source.antennaHeight);
            }
            return;
        }
        if (ReadUtil.isAnchorP2P(source)) {
            var typedSource = source;
            var cc = typedSource.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.p2p(cc, typedSource.value.placement);
            return;
        }
        if (ReadUtil.isAnchorManual(source)) {
            field.Mutator.manualAnchor(source.value);
            return;
        }
        return;
    };
    IkeModelCollectionReader.prototype.loadHeight = function (target, schema, source) {
        var e_5, _a;
        var field = target.getField(schema.id);
        if (ReadUtil.isHeightProviderManual(source)) {
            field.Mutator.manual(source.value);
            return;
        }
        if (ReadUtil.isHeightSpanHeightProvider(source)) {
            var cc = source.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.spanHeight(cc);
            return;
        }
        if (ReadUtil.isHeightPhotomeasureProvider(source) || ReadUtil.isHeightPhotomeasureManualProvider(source)) {
            try {
                for (var _b = tslib_1.__values(Array.from(this.collection.state.drawableStates.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var captureId = _c.value;
                    var drawableState = this.collection.getDrawableState(captureId);
                    if (!drawableState.hasDrawable(source.drawable)) {
                        continue;
                    }
                    var drawable = drawableState.getDrawable(source.drawable);
                    if (drawable == null) {
                        field.Mutator.manual(null); // TODO should we error here?
                        return;
                    }
                    field.Mutator.drawable(drawable);
                    return;
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            // Unable to find drawable
            field.Mutator.manual(source.value); // TODO should we error here?
            return;
        }
        throw new Error("Field ".concat(schema.id, ": Unable to parse Provider"));
    };
    IkeModelCollectionReader.prototype.loadVerticalSeparation = function (target, schema, source) {
        var e_6, _a;
        var field = target.getField(schema.id);
        if (!source.drawableTop || !source.drawableBottom) {
            field.Mutator.manual(source.value); // TODO should we error here?
            return;
        }
        try {
            for (var _b = tslib_1.__values(Array.from(this.collection.state.drawableStates.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var captureId = _c.value;
                var drawableState = this.collection.getDrawableState(captureId);
                // if one of the pairs is missing, continue
                if (!drawableState.hasDrawable(source.drawableTop) || !drawableState.hasDrawable(source.drawableBottom)) {
                    continue;
                }
                var drawableTop = drawableState.getDrawable(source.drawableTop);
                if (drawableTop == null) {
                    field.Mutator.manual(null); // TODO should we error here?
                    return;
                }
                var drawableBottom = drawableState.getDrawable(source.drawableBottom);
                // If a vertical separation drawable was not persisted, create one.
                // We do this because vertical separation drawables are a more recent addition
                // and not all collections have them in their persisted state.
                var drawableVertSep = source.drawable
                    ? drawableState.getDrawable(source.drawable)
                    : __1.CollectionModelDrawableVerticalSeparation.createWithLabel(drawableState, drawableTop.id, drawableBottom.id, field.id);
                field.Mutator.setDrawables(drawableTop, drawableBottom, drawableVertSep);
                // Link marker labels after the state is set so they don't call field.Mutator.drawable().
                // This prevents an issue where the captureJSON is not loaded yet at load time.
                drawableTop.label.linkVerticalSeparation(field);
                drawableBottom.label.linkVerticalSeparation(field);
                return;
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_6) throw e_6.error; }
        }
        // Unable to find drawable
        field.Mutator.manual(source.value); // TODO should we error here?
    };
    IkeModelCollectionReader.prototype.loadFileTool = function (target, schema, source) {
        var field = target.getField(schema.id);
        field.Mutator.manual({
            filename: source.filename,
            attachmentId: source.attachmentId,
            size: source.size,
            metadata: source.metadata
        });
    };
    IkeModelCollectionReader.prototype.readMeasurements = function () {
        var e_7, _a, e_8, _b;
        var collectionJSON = this.json;
        if (collectionJSON.measurements == null) {
            return;
        }
        var measurements = Object.keys(collectionJSON.measurements);
        if (measurements.length === 0) {
            return;
        }
        try {
            for (var measurements_1 = tslib_1.__values(measurements), measurements_1_1 = measurements_1.next(); !measurements_1_1.done; measurements_1_1 = measurements_1.next()) {
                var measurementId = measurements_1_1.value;
                var measurement = collectionJSON.measurements[measurementId];
                if (measurement == null) {
                    continue;
                }
                if (measurement.state.length === 0) {
                    continue;
                }
                if (measurement.captureId == null) {
                    throw new Error('Unable to read measurement, missing captureId ' + measurementId);
                }
                var drawableState = this.collection.getDrawableState(measurement.captureId);
                try {
                    for (var _c = (e_8 = void 0, tslib_1.__values(measurement.state)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var drawable = _d.value;
                        if (drawableState.drawables.has(drawable.id)) {
                            continue;
                        }
                        if (ReadUtil.isMarkerDrawable(drawable)) {
                            this.createMarkerDrawable(drawableState, drawable);
                        }
                        else if (ReadUtil.isLineDrawable(drawable)) {
                            this.createLineDrawable(drawableState, drawable);
                        }
                        else if (ReadUtil.isMaskDrawable(drawable)) {
                            this.createMaskDrawable(drawableState, drawable);
                        }
                        else if (ReadUtil.isVerticalSeparationDrawable(drawable)) {
                            this.createVerticalSeparationDrawable(drawableState, drawable);
                        }
                        else {
                            throw new Error('Unable to read drawable, unknown type ' + drawable.tag);
                        }
                    }
                }
                catch (e_8_1) { e_8 = { error: e_8_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_8) throw e_8.error; }
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (measurements_1_1 && !measurements_1_1.done && (_a = measurements_1.return)) _a.call(measurements_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
    };
    IkeModelCollectionReader.prototype.createMarkerDrawable = function (drawableState, obj) {
        var _a, _b;
        if (!obj.label) {
            throw new Error("Marker drawable requires a label state but one was not provided");
        }
        this.createLabelDrawable(drawableState, obj.label, obj.id);
        switch (obj.tag) {
            case 'marker':
                // NOTE: Currently Base Offset markers can be serialized with "tag" set to "marker"
                // but they are not Markers -- they are Marker Offsets -- so we check "tag" and "type".
                switch (obj.type) {
                    case core_api_1.MarkerType.NONE:
                        return new marker_drawable_1.CollectionModelDrawableMarker(drawableState, obj.id, obj.y, (_a = obj.label) === null || _a === void 0 ? void 0 : _a.id, obj.type, obj.insight, obj.pair);
                    case core_api_1.MarkerType.BASE:
                        return new marker_drawable_1.CollectionModelDrawableMarker(drawableState, obj.id, obj.y, (_b = obj.label) === null || _b === void 0 ? void 0 : _b.id, obj.type, obj.insight, obj.pair, obj.offset);
                    case core_api_1.MarkerType.BASE_OFFSET:
                        return new __1.CollectionModelDrawableMarkerOffset(drawableState, obj.id, obj.label.id);
                    default:
                        throw new Error("Unrecognized marker type: ".concat(obj['type']));
                }
            case 'offset':
                return new __1.CollectionModelDrawableMarkerOffset(drawableState, obj.id, obj.label.id);
            default:
                throw new Error("Unrecognized marker tag: ".concat(obj.tag));
        }
    };
    IkeModelCollectionReader.prototype.createLabelDrawable = function (drawableState, obj, parentId) {
        return new label_drawable_1.CollectionModelDrawableLabel(drawableState, obj.id, obj.x, obj.y, parentId, typeof obj.text === 'string' ? [obj.text] : obj.text, undefined);
    };
    IkeModelCollectionReader.prototype.createLineDrawable = function (drawableState, obj) {
        this.createLabelDrawable(drawableState, obj.label, obj.id);
        var start = new __1.CollectionModelDrawableLinePoint(drawableState, "".concat(obj.id, ":start"), obj.start.x, obj.start.y, obj.id);
        var end = new __1.CollectionModelDrawableLinePoint(drawableState, "".concat(obj.id, ":end"), obj.end.x, obj.end.y, obj.id);
        return new line_drawable_1.CollectionModelDrawableLine(drawableState, obj.id, obj.label.id, start.id, end.id);
    };
    IkeModelCollectionReader.prototype.createMaskDrawable = function (drawableState, obj) {
        if (!obj.pukeko_data) {
            throw new Error("Failed to deserialize Mask Drawable \"".concat(obj.id, "\": Pukeko data is missing"));
        }
        return new __1.CollectionModelDrawableMask(drawableState, obj.id, obj.pukeko_data);
    };
    IkeModelCollectionReader.prototype.createVerticalSeparationDrawable = function (drawableState, obj) {
        // Detect malformed data (primarily during development)
        if (!obj.topMarkerId || !obj.bottomMarkerId || !obj.fieldId || !obj.label || !obj.id) {
            throw new Error("Malformed vertical separation drawable state encountered during JSON deserialization (collection ".concat(this.collection.id, ") (capture ").concat(drawableState.captureId, "): ").concat(JSON.stringify(obj)));
        }
        var label = this.createLabelDrawable(drawableState, obj.label, obj.id);
        return new __1.CollectionModelDrawableVerticalSeparation(drawableState, obj.topMarkerId, obj.bottomMarkerId, obj.fieldId, label, obj.id);
    };
    IkeModelCollectionReader.prototype.readBrightnessCorrections = function () {
        var e_9, _a, e_10, _b;
        var collectionJSON = this.json;
        if (collectionJSON.brightnessCorrections == null) {
            return;
        }
        var brightnessCorrections = Object.keys(collectionJSON.brightnessCorrections);
        if (brightnessCorrections.length === 0) {
            return;
        }
        try {
            for (var brightnessCorrections_1 = tslib_1.__values(brightnessCorrections), brightnessCorrections_1_1 = brightnessCorrections_1.next(); !brightnessCorrections_1_1.done; brightnessCorrections_1_1 = brightnessCorrections_1.next()) {
                var brightnessCorrectionId = brightnessCorrections_1_1.value;
                var brightnessCorrection = collectionJSON.brightnessCorrections[brightnessCorrectionId];
                if (brightnessCorrection == null) {
                    continue;
                }
                if (brightnessCorrection.state.length === 0) {
                    continue;
                }
                if (brightnessCorrection.captureId == null) {
                    throw new Error('Unable to read brightness correction, missing captureId ' + brightnessCorrectionId);
                }
                var brightnessCorrectionState = this.collection.getBrightnessCorrectionState(brightnessCorrection.captureId);
                try {
                    for (var _c = (e_10 = void 0, tslib_1.__values(brightnessCorrection.state)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var drawableBrightnessCorrection = _d.value;
                        if (brightnessCorrectionState.brightnessCorrections[drawableBrightnessCorrection.id]) {
                            continue;
                        }
                        if (ReadUtil.isGammaBrightnessCorrection(drawableBrightnessCorrection)) {
                            this.createGammaBrightnessCorrection(brightnessCorrectionState, drawableBrightnessCorrection);
                        }
                        else {
                            continue; // TODO should we error here?
                        }
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (brightnessCorrections_1_1 && !brightnessCorrections_1_1.done && (_a = brightnessCorrections_1.return)) _a.call(brightnessCorrections_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
    };
    IkeModelCollectionReader.prototype.readImageVisibilities = function () {
        var e_11, _a;
        var collectionJSON = this.json;
        if (collectionJSON.imageVisibilities == null) {
            return;
        }
        var imageVisibilities = Object.keys(collectionJSON.imageVisibilities);
        if (imageVisibilities.length === 0) {
            return;
        }
        try {
            for (var imageVisibilities_1 = tslib_1.__values(imageVisibilities), imageVisibilities_1_1 = imageVisibilities_1.next(); !imageVisibilities_1_1.done; imageVisibilities_1_1 = imageVisibilities_1.next()) {
                var imageVisibilityId = imageVisibilities_1_1.value;
                var imageVisibility = collectionJSON.imageVisibilities[imageVisibilityId];
                if (imageVisibility == null || !imageVisibility.state) {
                    continue;
                }
                if (imageVisibility.captureId == null) {
                    throw new Error('Unable to read image visibility, missing captureId ' + imageVisibilityId);
                }
                var imageVisibilityState = this.collection.getImageVisibilityState(imageVisibility.captureId);
                if (imageVisibilityState.imageVisibility) {
                    continue;
                }
                if (ReadUtil.isHiddenImageVisibility(imageVisibility.state)) {
                    this.createHiddenImageVisibility(imageVisibilityState, imageVisibility.state);
                }
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (imageVisibilities_1_1 && !imageVisibilities_1_1.done && (_a = imageVisibilities_1.return)) _a.call(imageVisibilities_1);
            }
            finally { if (e_11) throw e_11.error; }
        }
    };
    IkeModelCollectionReader.prototype.createGammaBrightnessCorrection = function (brightnessCorrectionState, obj) {
        var gammaId = brightnessCorrectionState.Mutator.create('gamma', obj.id);
        var gamma = brightnessCorrectionState.getBrightnessCorrection(gammaId);
        var gammaState = gamma.state;
        gammaState.exponent = obj.exponent;
        return gamma;
    };
    IkeModelCollectionReader.prototype.createHiddenImageVisibility = function (hiddenImageVisibilityState, obj) {
        var hidden = hiddenImageVisibilityState.getImageVisibility();
        var hiddenState = hidden.state;
        hiddenState.hidden = obj.hidden;
        return hidden;
    };
    IkeModelCollectionReader.prototype.readCropParameters = function () {
        var e_12, _a, e_13, _b;
        var collectionJSON = this.json;
        if (collectionJSON.cropParameters == null) {
            return;
        }
        var cropParameters = Object.keys(collectionJSON.cropParameters);
        if (cropParameters.length === 0) {
            return;
        }
        try {
            for (var cropParameters_1 = tslib_1.__values(cropParameters), cropParameters_1_1 = cropParameters_1.next(); !cropParameters_1_1.done; cropParameters_1_1 = cropParameters_1.next()) {
                var cropParameterId = cropParameters_1_1.value;
                var cropParameter = collectionJSON.cropParameters[cropParameterId];
                if (cropParameter == null) {
                    continue;
                }
                if (cropParameter.state.length === 0) {
                    continue;
                }
                if (cropParameter.captureId == null) {
                    throw new Error('Unable to read crop parameter, missing captureId ' + cropParameterId);
                }
                var cropParameterState = this.collection.getCropParameterState(cropParameter.captureId);
                try {
                    for (var _c = (e_13 = void 0, tslib_1.__values(cropParameter.state)), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var drawableCropParameter = _d.value;
                        if (cropParameterState.cropParameters[drawableCropParameter.id]) {
                            continue;
                        }
                        if (ReadUtil.isFreeCropParameter(drawableCropParameter)) {
                            this.createFreeCropParameter(cropParameterState, drawableCropParameter);
                        }
                        else {
                            continue; // TODO should we error here?
                        }
                    }
                }
                catch (e_13_1) { e_13 = { error: e_13_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_13) throw e_13.error; }
                }
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (cropParameters_1_1 && !cropParameters_1_1.done && (_a = cropParameters_1.return)) _a.call(cropParameters_1);
            }
            finally { if (e_12) throw e_12.error; }
        }
    };
    IkeModelCollectionReader.prototype.createFreeCropParameter = function (cropParameterState, obj) {
        var freeId = cropParameterState.Mutator.create('free', obj.id);
        var free = cropParameterState.getCropParameter(freeId);
        var freeState = free.state;
        freeState.x = obj.x;
        freeState.y = obj.y;
        freeState.width = obj.width;
        freeState.height = obj.height;
        return free;
    };
    return IkeModelCollectionReader;
}());
exports.IkeModelCollectionReader = IkeModelCollectionReader;
//# sourceMappingURL=collection.model.read.js.map